var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataLightMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 228,
    viewBox: "0 0 305 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 114,
    r: 114,
    fill: "#DAE9EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_174_8180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 27H293C297.4 27 301 30.6 301 35V186C301 190.4 297.4 194 293 194H12C7.6 194 4 190.4 4 186V35C4 30.6 7.6 27 12 27Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 40H95C97.8 40 100 42.2 100 45C100 47.8 97.8 50 95 50H72C69.2 50 67 47.8 67 45C67 42.2 69.2 40 72 40Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 40H174C176.8 40 179 42.2 179 45C179 47.8 176.8 50 174 50H153C150.2 50 148 47.8 148 45C148 42.2 150.2 40 153 40Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 40H252C254.8 40 257 42.2 257 45C257 47.8 254.8 50 252 50H231C228.2 50 226 47.8 226 45C226 42.2 228.2 40 231 40Z",
    fill: "#006F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 55H287C291.4 55 295 58.6 295 63V88C295 92.4 291.4 96 287 96H18C13.6 96 10 92.4 10 88V63C10 58.6 13.6 55 18 55Z",
    fill: "#E8F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 136H287C291.4 136 295 139.6 295 144V169C295 173.4 291.4 177 287 177H18C13.6 177 10 173.4 10 169V144C10 139.6 13.6 136 18 136Z",
    fill: "#E8F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 71H110C112.8 71 115 73.2 115 76C115 78.8 112.8 81 110 81H71C68.2 81 66 78.8 66 76C66 73.2 68.2 71 71 71Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 152H110C112.8 152 115 154.2 115 157C115 159.8 112.8 162 110 162H71C68.2 162 66 159.8 66 157C66 154.2 68.2 152 71 152Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 71C125.8 71 128 73.2 128 76C128 78.8 125.8 81 123 81C120.2 81 118 78.8 118 76C118 73.2 120.2 71 123 71Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 152C125.8 152 128 154.2 128 157C128 159.8 125.8 162 123 162C120.2 162 118 159.8 118 157C118 154.2 120.2 152 123 152Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 111H102C104.8 111 107 113.2 107 116C107 118.8 104.8 121 102 121H70C67.2 121 65 118.8 65 116C65 113.2 67.2 111 70 111Z",
    fill: "#D1E8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 71H196C198.8 71 201 73.2 201 76C201 78.8 198.8 81 196 81H152C149.2 81 147 78.8 147 76C147 73.2 149.2 71 152 71Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 152H196C198.8 152 201 154.2 201 157C201 159.8 198.8 162 196 162H152C149.2 162 147 159.8 147 157C147 154.2 149.2 152 152 152Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 111H195C197.8 111 200 113.2 200 116C200 118.8 197.8 121 195 121H151C148.2 121 146 118.8 146 116C146 113.2 148.2 111 151 111Z",
    fill: "#D1E8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 71H274C276.8 71 279 73.2 279 76C279 78.8 276.8 81 274 81H230C227.2 81 225 78.8 225 76C225 73.2 227.2 71 230 71Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 152H274C276.8 152 279 154.2 279 157C279 159.8 276.8 162 274 162H230C227.2 162 225 159.8 225 157C225 154.2 227.2 152 230 152Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 111H273C275.8 111 278 113.2 278 116C278 118.8 275.8 121 273 121H229C226.2 121 224 118.8 224 116C224 113.2 226.2 111 229 111Z",
    fill: "#D1E8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 91C44.2843 91 51 84.2843 51 76C51 67.7157 44.2843 61 36 61C27.7157 61 21 67.7157 21 76C21 84.2843 27.7157 91 36 91Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 172C44.2843 172 51 165.284 51 157C51 148.716 44.2843 142 36 142C27.7157 142 21 148.716 21 157C21 165.284 27.7157 172 36 172Z",
    fill: "#BDDEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 132C44.2843 132 51 125.284 51 117C51 108.716 44.2843 102 36 102C27.7157 102 21 108.716 21 117C21 125.284 27.7157 132 36 132Z",
    fill: "#D1E8F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_174_8180",
    x: 0,
    y: 27,
    width: 305,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_8180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_174_8180",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLightMode);
export default __webpack_public_path__ + "static/media/NoDataLightMode.fc0bb121576373cadab29cbd27ae5b12.svg";
export { ForwardRef as ReactComponent };